export * from '@primeuix/themes/aura/iftalabel';
export { default } from '@primeuix/themes/aura/iftalabel';
